import lodash from 'lodash';
import Base from '../base.store';
import request from '../../../../utils/request';
import { filter } from '../../../../utils/search';

const baseUrl = '/api/v1/master/lab-country-standard-group-topic-lab-topics';
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        searchCountryStandardTopics(context, { searchQuery, labTypeKey, productId, countryId1, countryId2, config, where = [], sort = [] }) {
            const criteria = {
                labTypeKey: labTypeKey,
                countryId1: countryId1,
                countryId2: countryId2,
                productId: productId
            };
            return request.put(`${baseUrl}/country-standard-topics`, criteria, { ...config }).then(list => {
                list.map(it => ({ ...it.refLabTopic }));
                if (searchQuery) {
                    where.push([{ name: 'name', type: 'String', operator: 'like', value: searchQuery }]);
                }
                const filterList = filter({ list, where, sort });
                return filterList;
            });
        }
    },
    mutations: {
        ...base.mutations
    }
};
